/* eslint-disable no-console */
import zukeeper from 'zukeeper';
import {create} from 'zustand';

// Correct interface name and property names
interface PlatformStore {
  onBoarding: boolean;
  openOnBoardingMessageModel: boolean;
  openOnFreeTrialMessageModel: boolean;
  setOpenOnBoardingMessageModel: (status: boolean) => void;
  setOpenOnFreeTrialMessageModel: (status: boolean) => void;
}

const usePlatformStore = create<PlatformStore>()(
  zukeeper(
    // This enables persistence (localStorage)
    (set: any) => ({
      openOnBoardingMessageModel: false,
      openOnFreeTrialMessageModel: false,

      setOpenOnBoardingMessageModel: (status: boolean) =>
        set(() => ({openOnBoardingMessageModel: status})),

      setOpenOnFreeTrialMessageModel: (status: boolean) =>
        set(() => ({openOnFreeTrialMessageModel: status}))
    }),
    {
      name: 'platform-store' // Required: unique name for localStorage
    }
  )
);

export default usePlatformStore;
